module.exports = __webpack_public_path__ + "img/Symbol_Bonus.af2e0296.png";